import React from 'react';
import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { find, get } from 'lodash';
import useProductFilters from './ProductFilterHelper';
import { useGetProductsHandler } from '../dataHandlers/getProductsHandler';

const ProductSelect = ({
  label,
  name,
  control,
  errors,
  readOnly = false,
  disabled = false,
  onOptionSelect,
  isOptionDisabled,
}) => {
  const { currentQuery, handleSearchChange } = useProductFilters({ defaultQuery: {}, searchOnChange: true });
  const { products, isLoading } = useGetProductsHandler({ searchQuery: currentQuery });
  const errorMessage = get(errors, `${name}.message`, '');
  const options = products || [];

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const selectedOption = find(options, { stripe_product_id: field?.value }) || null;

        return (
          <Box display="flex" alignItems="flex-start" gap={2}>
            <Autocomplete
              id={name}
              fullWidth
              loading={isLoading}
              readOnly={readOnly}
              disabled={disabled}
              options={options}
              getOptionDisabled={(option) => {
                return isOptionDisabled ? isOptionDisabled(option) : false;
              }}
              getOptionLabel={(value) => {
                if (typeof value === 'string') {
                  let option = find(options, { stripe_product_id: value });
                  return option?.name || '-';
                }
                return value?.name || '-';
              }}
              getOptionKey={(option) => {
                return option;
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  error={!!errorMessage}
                  helperText={errorMessage}
                  slotProps={{
                    input: {
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    },
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => {
                return option.stripe_product_id === value?.stripe_product_id;
              }}
              onChange={(_, value) => {
                const finalValue = value?.stripe_product_id || '';
                field.onChange(finalValue);
                if (onOptionSelect) onOptionSelect(value || null);
              }}
              value={selectedOption}
              onInputChange={(_, value, reason) => {
                if (reason === 'input') {
                  handleSearchChange(value);
                }
              }}
              filterOptions={(x) => x}
            />
          </Box>
        );
      }}
    />
  );
};

export default ProductSelect;
